import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
// import { FaPhoneAlt, FaWhatsapp, FaEnvelope } from "react-icons/fa";
// import "./Labour.css";



const labourData = [
    {
    id: "l1",
    name: "M Faisal",
    role: "Senior Painter",
    exp: 24,
    bio: "Expert in exterior coatings, scaffolding experience and epoxy finishes.",
    img: "/Gallerypics/Faislal DType faisalabd 2.jpg"
  },
  {
    id: "l2",
    name: "Chand Ali",
    role: "Interior Specialist",
    exp: 24,
    bio: "Color consultant experience, detail-oriented trim and cabinetry work.",
    img: "/Gallerypics/Chand.jpg"
  },
  {
    id: "l3",
    name: "Amir Ali",
    role: "Ceiling Specialist",
    exp: 23,
    bio: "Skilled in ceiling textures, popcorn removal and dust-free finishes.",
    img: "/Gallerypics/Amir Edit.png"
  },
  {
    id: "l4",
    name: "Asgher Ali",
    role: "Industrial Coater",
    exp: 21,
    bio: "Anti-corrosion coatings and high-build industrial finishes.",
    img: "/Gallerypics/Asger Labour.jpg"
  }
  , {
    id: "l4",
    name: "Riasat Ali",
    role: "All Rounder",
    exp: 20,
    bio: "Anti-corrosion coatings and high-build industrial finishes.",
    img: "/Gallerypics/Gonga1.jpg"
  }
];

export default function Labour() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
      }, []);    
      const animations = ["fade-up", "fade-right", "fade-left",'fade-down'];

      return (
    <section className="labour-section">
      <div className="labour-header">
        <h3 className="labour-sub">OUR TEAM</h3>
        <h2 className="labour-title">Skilled Labour & Crew</h2>
        <p className="labour-intro">Meet our experienced crew — available for residential, commercial and industrial jobs.</p>
      </div>

      <div className="labour-grid">
        {labourData.map((p) => (
          <article className="labour-card" key={p.id} data-aos={animations[p % animations.length]}
            data-aos-delay={p * 100}>
            <div className="labour-imgwrap "  >
              <img src={p.img} alt={p.name} className="labour-img"  />
            </div>

            <div className="labour-body">
              <h4 className="labour-name">{p.name}</h4>
              <p className="labour-role">{p.role} · <span className="labour-exp">{p.exp} yrs</span></p>
              <p className="labour-bioo">{p.bio}</p>
            </div>

            {/* <div className="labour-overlay">
              <p className="labour-bio">{p.bio}</p>
              <div className="labour-actions">
                <a className="btn btn-call" aria-label={`Call ${p.name}`}>
                  <FaPhoneAlt /> Inspire
                </a>
                <a className="btn btn-ws"  target="_blank" rel="noreferrer" aria-label={`WhatsApp ${p.name}`}>
                  <FaWhatsapp /> WhatsApp
                </a>
                <a className="btn btn-hire"  aria-label={`Hire ${p.name}`}>
                  <FaEnvelope /> Hire
                </a>
              </div>
            </div> */}
          </article>
        ))}
      </div>
    </section>
  );
}
